export const fontWeight = {
    REGULAR: 400,
    MEDIUM: 500,
    BOLD: 700
}